import React from 'react';
import InformationBox from '../reusable/InformationBox';
import { formatApprovalDate } from './dateFormatting';

interface DataQcApprovedStateProps {
  approvals: Array<{
    district_data_qc_approved_at: string;
    district_data_qc_approved_by: string;
    district_data_qc_approved_by_role: string;
  }>;
}

const DataQcApprovedState: React.FC<DataQcApprovedStateProps> = ({ approvals }) => {
  if (!approvals || approvals.length === 0) {
    return null;
  }

  // Get the most recent approval
  const latestApproval = approvals[approvals.length - 1];
  const { district_data_qc_approved_by, district_data_qc_approved_by_role, district_data_qc_approved_at } =
    latestApproval;

  const formatApprovalMessage = () => {
    const formattedDate = formatApprovalDate(district_data_qc_approved_at);

    if (district_data_qc_approved_by_role === 'DISTRICT_DATA_LEAD') {
      return `Data quality check approved by ${district_data_qc_approved_by} on ${formattedDate}`;
    } else {
      const userDisplayName =
        district_data_qc_approved_by_role === 'XQ_ADMIN'
          ? `${district_data_qc_approved_by} (XQ Admin)`
          : district_data_qc_approved_by;
      return `Approved by ${userDisplayName} on ${formattedDate}`;
    }
  };

  return (
    <InformationBox type="success" title="Data quality check approved">
      <p>{formatApprovalMessage()}</p>
    </InformationBox>
  );
};

export default DataQcApprovedState;
